import { AutospinValues } from '../../classes/values/autospinValues/autospinValues.class'

/**
 * @file Defines the {@link AUTOSPIN_VALUES} constant
 * @author Joe Thompson <joe.thompson@1x2network.com>
 */

 /**
  * Constant instance of Values to be used by new UI
  * @type {AutospinValues}
  */

 export const AUTOSPIN_VALUES = new AutospinValues()